module.exports = __webpack_public_path__ + "img/big7-3.a4cbcb5f.jpg";